import React from 'react'
import { Helmet } from 'react-helmet-async'
import SEO from '../components/SEO'
import Navbar from '../components/Navbar'
import Hero from '../components/Hero'
import About from '../components/About'
import Services from '../components/Services'
import Products from '../components/Products'
import Testimonials from '../components/Testimonials'
import Contact from '../components/Contact'
import GetQuote from '../components/GetQuote'
import Footer from '../components/Footer'
// import Chatbot from '../components/Chatbot'

const structuredData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://rasteghub.co.ke/#organization",
      "name": "RaStegHub",
      "url": "https://rasteghub.co.ke",
      "logo": { "@type": "ImageObject", "url": "https://rasteghub.co.ke/logo192.png" },
      "description": "RaStegHub is a product-driven tech innovation hub based in Nairobi, Kenya.",
      "address": { "@type": "PostalAddress", "addressLocality": "Nairobi", "addressCountry": "KE" },
      "contactPoint": { "@type": "ContactPoint", "email": "hello@rasteghub.co.ke", "contactType": "customer service" },
      "sameAs": ["https://twitter.com/rasteghub", "https://instagram.com/rasteghub", "https://linkedin.com/company/rasteghub"]
    },
    {
      "@type": "LocalBusiness",
      "name": "RaStegHub",
      "url": "https://rasteghub.co.ke",
      "email": "hello@rasteghub.co.ke",
      "address": { "@type": "PostalAddress", "addressLocality": "Nairobi", "addressRegion": "Nairobi County", "addressCountry": "KE" },
      "geo": { "@type": "GeoCoordinates", "latitude": -1.286389, "longitude": 36.817223 },
      "priceRange": "KSh 20,000+",
      "openingHours": "Mo-Fr 09:00-18:00",
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Tech Services",
        "itemListElement": [
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Software Development" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "UI/UX Design" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Social Media Management" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "SEO" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Mentorship & Training" } },
          { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Ready-Made Solutions" } }
        ]
      }
    }
  ]
}

function Home() {
  return (
    <>
      <SEO
        description='RaStegHub is a tech innovation hub in Nairobi building software, SaaS products, and digital solutions for businesses across Africa.'
        url='/'
      />
      <Helmet>
        <script type='application/ld+json'>{JSON.stringify(structuredData)}</script>
      </Helmet>
      <div>
        <Navbar />
        <Hero />
        <About />
        <Services />
        <Products />
        <Testimonials />
        <Contact />
        <GetQuote />
        <Footer />
        {/* <Chatbot /> */}
      </div>
    </>
  )
}

export default Home